import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import { DialogTitle, IconButton, DialogActions } from "@mui/material"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import Grid from "@mui/material/Unstable_Grid2" // Grid version 2
import React, { useContext } from "react"
import { useDispatch, useSelector } from "react-redux"
import { yupResolver } from "@hookform/resolvers/yup"
import { FormProvider, useForm } from "react-hook-form"
import * as yup from "yup"
import TokenContext from "../../context/TokenContext"
import { obtenerDisciplinas, obtenerSubdisciplinas, obtenerUniversidades } from "../../Redux/autocompletados"
import { UserAuth } from "../../context/AuthContext"
import CustomSelect from "../CustomSelect"
import CustomSearchSelect from "../CustomSearchSelect"
import CustomTextField from "../CustomTextField"
import CustomDateField from "../CustomDateField"

const ModalProyectos = ({ open, handleClose, onSubmit }) => {
    const token = useContext(TokenContext)
    const dispatch = useDispatch()
    const { empleado } = UserAuth()

    const [universidades, setUniversidades] = React.useState([])
    const loadingUniversidades = useSelector((store) => store.autocompletados.loadingUniversidades);

    React.useEffect(() => {
        if (token) {
            dispatch(obtenerUniversidades(token))
            dispatch(obtenerDisciplinas(token))
            dispatch(obtenerSubdisciplinas(token));
        }
    }, [token]);

    React.useEffect(() => {
        if (loadingUniversidades?.length > 0) {
            const universidades = [];
            loadingUniversidades.forEach((item) => {
                const object = {
                    value: item.new_universidadid,
                    label: item.new_name,
                };
                universidades.push(object);
            });
            setUniversidades(universidades);
        }
    }, [loadingUniversidades])


    const defaultValues = {
        new_name: '',
        new_fechadeinicio: '',
        new_fechadefinalizacin: '',
        _new_institucion_value: '',
        _new_institucionevaluadora_value: '',
        _new_institucionfinanciadora_value: '',
        new_carcterdelaparticipcin: '',
        new_principalesresultados: '',
    }

    const validacionSchema = yup.object().shape({
        new_name: yup.string().required("Required"),
        new_fechadeinicio: yup.string().required("Required"),
        _new_institucion_value: yup.object({value: yup.string().required("Required") }),
        _new_institucionevaluadora_value: yup.object({value: yup.string().required("Required") }),
        _new_institucionfinanciadora_value: yup.object({value: yup.string().required("Required") }),
        new_carcterdelaparticipcin: yup.number().required("Required"),
    })

    const methods = useForm({
        shouldUnregister: false,
        defaultValues,
        resolver: yupResolver(validacionSchema),
        mode: "onChange",
        shouldFocusError: true,
    })

    const { handleSubmit, reset } = methods

    const submitDatos = (datos) => {
        onSubmit(datos)
    }

    const opcionesCaracter = [
        { label: 'investigador', value: 100000000 },
    ]


    return (
        <Dialog
            fullWidth={true}
            maxWidth={'md'}
            open={open}
            onClose={handleClose}
        >
            <DialogTitle>Crear proyecto de investigación</DialogTitle>
            <FormProvider {...methods}>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid xs={12} sm={6} item sx={{ pt: 0, pb: 0 }}>
                            <CustomTextField
                                Component={TextField}
                                name="new_name"
                                label="Título"
                                rules={{ required: "Required!" }}
                                helperText="Por favor indica el título."
                                className="custom-helper"
                                req={true}
                            />
                        </Grid>
                        <Grid xs={12} sm={6} item sx={{ mt: 1 }}>
                            <CustomDateField
                                name="new_fechadeinicio"
                                label="Fecha de inicio:"
                                rules={{ required: "Required!" }}
                                helperText="Por favor indica la fecha de inicio"
                                req={true}
                                className="custom-helper"
                            />
                        </Grid>
                        <Grid xs={12} sm={6} item sx={{ mt: 1 }}>
                            <CustomDateField
                                name="new_fechadefinalizacin"
                                label="Fecha de finalización:"
                                rules={{ required: "Required!" }}
                                req={false}
                                helperText="Por favor indica la fecha de finalización"
                                className="custom-helper"
                            />
                        </Grid>
                        <Grid xs={12} sm={6} item sx={{ pt: 0, pb: 0 }}>
                            <CustomSearchSelect
                                options={universidades}
                                type="text"
                                name="_new_institucion_value"
                                lab="Institución"
                                helperText="Por favor seleccione un valor"
                                req={true}
                            />
                        </Grid>
                        <Grid xs={12} sm={6} item sx={{ pt: 0, pb: 0 }}>
                            <CustomSearchSelect
                                options={universidades}
                                type="text"
                                name="_new_institucionevaluadora_value"
                                lab="Institución Evaluadora"
                                helperText="Por favor seleccione un valor"
                                req={true}
                            />
                        </Grid>
                        <Grid xs={12} sm={6} item sx={{ pt: 0, pb: 0 }}>
                            <CustomSearchSelect
                                options={universidades}
                                type="text"
                                name="_new_institucionfinanciadora_value"
                                lab="Institución Financiadora"
                                helperText="Por favor seleccione un valor"
                                req={true}
                            />
                        </Grid>
                        <Grid xs={12} sm={6} item sx={{ pt: 0, pb: 0 }}>
                            <CustomSelect
                                fullWidth
                                name="new_carcterdelaparticipcin"
                                label="Carácter de la Participación"
                                helperText="Por favor seleccione un valor"
                                options={opcionesCaracter}
                                rules={{ required: "Required!" }}
                                required={true}
                                className="custom-helper"
                            />
                        </Grid>
                        <Grid xs={12} sm={6} item sx={{ pt: 0, pb: 0 }}>
                            <CustomTextField
                                Component={TextField}
                                name="new_principalesresultados"
                                label="Principales Resultados"
                                multiline
                                rules={{ required: "Required!" }}
                                helperText="Por favor indica los resultados."
                                className="custom-helper"
                                
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleClose()} color="secondary" >
                        <Typography sx={{ fontWeight: 'bold' }}>Cerrar</Typography>
                    </Button>
                    <Button
                        type="submit"
                        variant="text"
                        color="secondary"
                        onClick={handleSubmit(submitDatos)}
                    >
                        <Typography sx={{ fontWeight: 'bold' }}>Crear</Typography>
                    </Button>
                </DialogActions>
            </FormProvider>
        </Dialog>
    )
}

export default ModalProyectos